import React from 'react'
import Routes from './components/Routes/Routes'

const App = () => {
  return (
    <div><Routes /></div>
  )
}

export default App